module.exports = __webpack_public_path__ + "static/media/Chen1.3a478f8c.png";